import moment from 'moment';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';
import { layout, mediaQuery } from '@modernhealth/vital-foundation';
import {
    Button,
    HeadingText30,
    HeadingText40,
    HeadingText50,
    pxToRem,
} from '@modernhealth/vital-components';
import { milestones } from '../util/milestones';

import { appClient } from 'src/config/apollo';
import { useGetScheduledContentActivityQuery } from 'src/modules/scheduledContent/documents/getScheduledContentActivity.generated';
import { MilestoneList } from 'src/modules/scheduledContent/components/MilestoneList';
import { captureException } from 'src/shared/helpers/captureException';
import { MilestoneListSkeletons } from '../components/DailyPauseSkeletons';

const Wrapper = styled.div({
    width: '100%',
    maxWidth: layout.containerWidth,
    margin: '0 auto',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingBottom: layout.footerHeight,
});

const BackButton = styled(Button)({
    marginTop: pxToRem(4),
    marginLeft: pxToRem(-18),
});

export const DailyPauseMilestones = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('sm', true));
    const PageHeader = smallScreenDetected ? HeadingText40 : HeadingText50;
    const PageDescription = smallScreenDetected ? HeadingText30 : HeadingText40;

    const currentYearMonth = moment().format('Y-MM');
    const { data, loading, error } = useGetScheduledContentActivityQuery({
        variables: { from: `${currentYearMonth}-01` },
        client: appClient,
    });

    useEffect(() => {
        if (error) {
            captureException(error);
        }
    }, [error]);

    if (loading && !data) {
        return (
            <Wrapper>
                <MilestoneListSkeletons elementsCount={milestones.length} />
            </Wrapper>
        );
    }

    if (!data?.scheduledContentActivity) {
        // TODO: handle this rare edge case better
        history.push('/dashboard');
    }

    const completedCount = data?.scheduledContentActivity?.completedCount;

    return (
        <Wrapper>
            <BackButton
                variant="flat"
                size="medium"
                icon="arrow-left"
                onClick={() => {
                    history.push('/pause/stats');
                }}
            />
            <PageHeader marginTop={22} marginBottom={44}>
                {t('dailyPause:milestones.title')}
            </PageHeader>
            <PageDescription marginBottom={52}>
                {t('dailyPause:milestones.description')}
            </PageDescription>
            <MilestoneList milestoneList={milestones} completedCount={completedCount} />
        </Wrapper>
    );
};
